import { Pipe, PipeTransform } from '@angular/core';
import { EUserRole } from '../../features/user-management/models/user.model';
import { ROLE_DISPLAY_MAP } from '../../features/user-management/user-management-filters/user-management-filters.component';

@Pipe({
  name: 'roleDisplay',
  standalone: true,
})
export class RoleDisplayPipe implements PipeTransform {
  transform(role: string): string {
    return ROLE_DISPLAY_MAP[role as EUserRole] ?? role;
  }
}
